// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-widget {
  border: 1px solid #aa004f;
  box-sizing: border-box;
  cursor: pointer;
  width: 25px;
  height: 25px;
  display: flex;
}
.checkbox-widget input {
  display: none;
}
.checkbox-widget svg {
  padding: 3px;
}
.checkbox-widget[data-checked=false] img {
  visibility: hidden;
}
.checkbox-widget[data-checked=true] {
  background-color: #aa004f;
  padding: 3px;
  box-sizing: border-box;
}
.checkbox-widget[data-checked=true] img {
  width: 100%;
  visibility: visible;
  min-width: 23px;
  padding: 3px;
  margin-left: -3px;
}`, "",{"version":3,"sources":["webpack://./src/widgets/CheckBox/styles.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AACA;EACE,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAAF;AACE;EACE,aAAA;AACJ;AACE;EACE,YAAA;AACJ;AAEI;EACE,kBAAA;AAAN;AAGE;EACE,yBCfK;EDgBL,YAAA;EACA,sBAAA;AADJ;AAEI;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAAN","sourcesContent":["@import \"../../css/colors\";\n.checkbox-widget {\n  border: 1px solid $color6;\n  box-sizing: border-box;\n  cursor: pointer;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  input {\n    display: none;\n  }\n  svg {\n    padding: 3px;\n  }\n  &[data-checked=\"false\"] {\n    img {\n      visibility: hidden;\n    }\n  }\n  &[data-checked=\"true\"] {\n    background-color: $color6;\n    padding: 3px;\n    box-sizing: border-box;\n    img {\n      width: 100%;\n      visibility: visible;\n      min-width: 23px;\n      padding: 3px;\n      margin-left: -3px;\n    }\n  }\n}\n","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
